import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import {URLS} from '../../constants/appConstants';
import {useNavigate} from 'react-router-dom';

const style = {
  margin: 0,
  top: 'auto',
  right: 20,
  bottom: 70,
  left: 'auto',
  position: 'fixed',
};

export default function CreateFAB() {
  const navigate = useNavigate();
  return <>
    <Fab color="primary" aria-label="add" size="medium" style={style}
         onClick={() => navigate(URLS.SELECT_QUESTION_TYPE)}>
      <AddIcon/>
    </Fab>
  </>
}
